<app-modal
  [isOpen]="true"
  [title]="'Registrar Priorización'"
  [widthPx]="520"
  (closeModal)="onClose()"
>
  <div class="prioritization-form">
    <!-- Case Info -->
    <div class="case-info-section">
      <div class="info-row">
        <span class="info-label">Código LG</span>
        <span class="info-value">{{ caseItem().lgNumber || '-' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Paciente</span>
        <span class="info-value">{{ caseItem().patientName || (caseItem().patientFirstName + ' ' + caseItem().patientLastName) }}</span>
      </div>
    </div>

    <!-- Prioritization Toggle -->
    <div class="toggle-section">
      <label class="toggle-container">
        <input
          type="checkbox"
          class="toggle-input"
          [checked]="prioritized()"
          (change)="onTogglePrioritization($any($event.target).checked)"
          [disabled]="isSaving()"
        />
        <span class="toggle-label">¿Tiene priorización?</span>
      </label>
    </div>

    <!-- Reason Field -->
    <div class="reason-section">
      <label class="reason-label" for="prioritization-reason">
        Razón de priorización
      </label>
      <textarea
        id="prioritization-reason"
        class="reason-textarea"
        [ngModel]="reason()"
        (ngModelChange)="reason.set($event)"
        [disabled]="!prioritized() || isSaving()"
        placeholder="Ingrese la razón de priorización..."
        rows="2"
        maxlength="500"
      ></textarea>
      @if (prioritized()) {
        <span class="char-counter">{{ reason().length }}/500</span>
      }
    </div>

    <!-- Actions -->
    <div class="actions-section">
      <app-button
        [label]="'Cancelar'"
        [type]="ButtonTypeEnum.SECONDARY"
        [size]="ButtonSizeEnum.MD"
        [disabled]="isSaving()"
        (handleClick)="onClose()"
      />
      <app-button
        [label]="isSaving() ? 'Guardando...' : 'Guardar'"
        [type]="ButtonTypeEnum.PRIMARY"
        [size]="ButtonSizeEnum.MD"
        [disabled]="isSaving()"
        (handleClick)="onSave()"
      />
    </div>
  </div>
</app-modal>
